module.exports = __webpack_public_path__ + "assets/img/tag.29b1fedc.svg";